/*
 * @author: yanhoup
 * @description: 顶部仓库下拉选择
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useLocalStorageState } from 'ahooks';
import { MenuButton } from '@fpxfd/next';
import styles from './index.module.scss';
import { getWarehouse } from './index.service';

const { Item } = MenuButton;

interface WarehouseItem {
  name: string;
  code: string;
  selected: boolean;
}

export default () => {
  const [menu, setMenu] = useLocalStorageState<WarehouseItem[]>('wareMenu', []);
  const [wareCode, setWareCode] = useLocalStorageState<string>('wareCode', '');
  const [name, setName] = useState('');

  useEffect(() => {
    getWarehouse().then((res) => {
      if (!res[0]) {
        localStorage.removeItem('wareMenu');
        localStorage.removeItem('wareCode');
      }
      setMenu(res[0]?.warehouses);
      if (!wareCode) {
        setName(res[0]?.warehouses[0].name);
        setWareCode(res[0]?.warehouses[0].code);
      } else {
        const item = res[0]?.warehouses.find((e) => e.code === wareCode);
        setName(item?.name);
      }
    });
  }, []);

  const warehouseChange = useCallback(
    (value) => {
      setWareCode(value);
      window.localStorage.setItem('showacrtle', '1');
      location.reload();
    },
    [menu],
  );

  return (
    <MenuButton
      label={name}
      text
      popupTriggerType="click"
      popupClassName={styles.WarehousePop}
      onItemClick={(value) => warehouseChange(value)}
      className={styles.Warehouse}
      autoWidth={false}
      data-i18n-ignore-content
    >
      {menu &&
        menu.map((item: any) => (
          <Item key={item.code} title={item.name}>
            {item.name}
          </Item>
        ))}
    </MenuButton>
  );
};
